import { termosStep } from '../../shared/termosSections';
import {
  identificacaoSociedadeSection,
  enderecoAdvogadoESociedadeStep,
  DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL_ADVOGADO,
  DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL_SOCIEDADE
} from '../../shared/sociedadeSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';
import { SUBUNIDADES_OAB_MS } from '../../shared/subUnidadesOabMs';

const pedidoRegistroSociedadeUnipessoalConfig = {
  id: 'pedido_registro_sociedade_unipessoal',
  nome: 'Pedido de Registro de Sociedade Individual',
  descricao: 'Solicitação de registro de sociedade individual de advocacia (unipessoal)',
  icon: 'FaFileContract',
  categoria: 'sociedades',
  // Só advogado(a) adimplente com a OAB/MS pode registrar sociedade (ver
  // oabData.isInadimplente no login) — checado em DynamicPedidoPage.js, que mostra
  // uma mensagem explicando o motivo em vez de esconder o pedido da listagem.
  bloqueiaInadimplente: true,

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'contratoSocial', tipoDocumentoProcesso: 199, name: 'Contrato Social', description: 'Contrato social da sociedade', required: true },
      { id: 'copiaDocumentoSocio', tipoDocumentoProcesso: 289, name: 'Cópia do Documento do Sócio', description: 'Cópia do documento de identidade do sócio', required: true },
      { id: 'dbe', tipoDocumentoProcesso: 375, name: 'DBE - Documento Básico de Entrada', description: 'Documento Básico de Entrada, gerado no site da Redesim', required: true }
    ]
  },

  paymentConfig: {
    amount: 389.00
  },

  protocoloConfig: {
    modeloRequerimento: '194',
    tiposAssunto: '268',
    tipoPedido: '221',
    // Cria a PJ da sociedade (POST /pessoa/juridica) antes do /criar e manda o ID
    // dela em nomeSociedade — ver sociedadePessoaJuridicaService.js.
    criarSociedadePessoaJuridica: true
  },

  // Confirmado ao vivo — sem campo local pro "Nome" do advogado (o form só
  // coleta nomeSociedade), então esse campo da API fica de fora.
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'valorCapitalSocial', campoNome: 'ValorCapitalSocial' },
        { field: 'subsecaoSociedade', campoNome: 'SubUnidadeAtual' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL_ADVOGADO,
    DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL_SOCIEDADE
  ),

  tituloConfig: {
    tipoLancamentoId: 95,
    enderecoOrigem: 'residencialAdvogadoSociedade'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection([
          { type: 'currency', name: 'valorCapitalSocial', label: 'Valor do Capital Social', required: true, placeholder: 'Ex: R$ 10.000,00' },
          { type: 'select', name: 'subsecaoSociedade', label: 'Subseção da Sociedade', required: true, placeholder: 'Selecione a subseção', options: SUBUNIDADES_OAB_MS }
        ], { incluirCnpj: false })
      ]
    },
    enderecoAdvogadoESociedadeStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoRegistroSociedadeUnipessoalConfig;
